import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { clickOutside } from "./directives/clickOutside";

import "./assets/tailwind.css";

const app = createApp(App);
const pinia = createPinia();

// Register custom directive
app.directive("click-outside", clickOutside);

app.use(router);
app.use(pinia);

app.mount("#app");